<template>
  <v-container>
    <div class="d-block d-md-flex">
      <AppAside></AppAside>
      <div class="ps-5 page_content grow">
        <v-card>
          <v-card-text>
            <h1 class="text-h4 my-5" v-if="edit_loaded">{{ page_title }}</h1>

            <v-row v-if="!edit_loaded">
              <v-col v-for="i in 5" :key="i" cols="6" sm="3">
                <v-skeleton-loader type="list-item-two-line"></v-skeleton-loader>
              </v-col>
            </v-row>

            <div v-if="!edit_loaded">
              <v-col v-for="i in 3" :key="i" cols="12" sm="6">
                <v-skeleton-loader type="list-item-two-line"></v-skeleton-loader>
              </v-col>
            </div>

            <v-form ref="form" v-if="edit_loaded">
              <Form
                :compare_dates="compare_dates"
                :item="item"
              ></Form>
              <v-btn
                v-if="
                  this.$route.params.id
                    ? this.$store.getters.permission('brand_campaigns edit')
                    : this.$store.getters.permission('brand_campaigns create')
                "
                @click="save()"
                class="mb-10"
                color="primary"
                width="200"
                height="50"
                x-large
                :disabled="save_loader"
                :loading="save_loader"
              >שמירה</v-btn>
            </v-form>
          </v-card-text>
        </v-card>

        <v-snackbar left v-model="snackbar_success">
          <p class="white--text">עודכן {{ page_title }}</p>
          <template v-slot:action>
            <v-icon color="success" class="ms-3">check_circle</v-icon>
          </template>
        </v-snackbar>

        <v-snackbar color="error" left v-model="snackbar_err">
          <p class="white--text">בבקשה לבדוק הכל</p>
          <template v-slot:action>
            <v-icon color="white" class="ms-3">error</v-icon>
          </template>
        </v-snackbar>
      </div>
    </div>
  </v-container>
</template>

<script>
import Form from "@/components/brand_campaigns/form";

export default {
  name: "BrandCampaign",
  data() {
    return {
      save_loader: false,
      edit_loaded: false,
      snackbar_success: false,
      snackbar_err: false,
      page_title: "",
      item: {
        campaign_name: "",
        total_to_get_discount: 0,
        delivery_discount_percentage: 0,
        start_date: null,
        end_date: null,
        status: true,
        brands: [],
      },
    };
  },
  components: { Form },
  computed: {
    compare_dates() {
      if (!this.item.start_date || !this.item.end_date) return true;
      return this.item.start_date <= this.item.end_date;
    },
  },
  mounted() {
    if (this.$route.params.id) {
      this.page_title = "עריכת מבצע מותג";
      this.get_item(this.$route.params.id);
    } else {
      this.page_title = "מבצע מותג חדש";
      this.edit_loaded = true;
    }
  },
  methods: {
    get_item(id) {
      this.$store
        .dispatch("public__request", {
          config: {
            url: `brand-campaigns/${id}`,
            method: "get",
          },
        })
        .then((res) => {
          const data = res.data.data;
          this.item = {
            campaign_name: data.campaign_name,
            total_to_get_discount: data.total_to_get_discount,
            delivery_discount_percentage: data.delivery_discount_percentage,
            start_date: data.start_date,
            end_date: data.end_date,
            status: data.status,
            brands: data.brands
              ? data.brands.map((b) => ({
                  id: b.brand_id,
                  name: b.brand ? b.brand.name : "",
                  image: b.brand ? b.brand.image : "",
                }))
              : [],
          };
          this.edit_loaded = true;
        });
    },
    save() {
      if (!this.$refs.form.validate()) return;
      if (this.save_loader) return;
      if (
        this.$route.params.id
          ? !this.$store.getters.permission("brand_campaigns edit")
          : !this.$store.getters.permission("brand_campaigns create")
      )
        return;

      this.save_loader = true;
      const payload = {
        campaign_name: this.item.campaign_name,
        total_to_get_discount: this.item.total_to_get_discount,
        delivery_discount_percentage: this.item.delivery_discount_percentage,
        start_date: this.item.start_date,
        end_date: this.item.end_date,
        status: this.item.status ? 1 : 0,
        brands: this.item.brands.map((b) => ({ brand_id: b.id })),
      };

      this.$store
        .dispatch("public__request", {
          config: {
            url: this.$route.params.id
              ? `brand-campaigns/${this.$route.params.id}`
              : "brand-campaigns",
            method: this.$route.params.id ? "put" : "post",
          },
          data: payload,
        })
        .then(() => {
          this.snackbar_success = true;
          this.save_loader = false;
          setTimeout(() => {
            this.$router.push("/brand-campaigns");
          }, 1000);
        })
        .catch(() => {
          this.snackbar_err = true;
          this.save_loader = false;
        });
    },
    reset_counter() {
      this.item.sale_counter = 0;
    },
  },
};
</script>
